<template>
    <v-container fluid>
        <h1>Mis comentarios</h1>
        <v-card :loading="loading">
            <v-card-title>
                <v-text-field
                    v-model="searchComentario1"
                    append-icon="mdi-account-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headersListarComentarios" :items="separarComentarios('privado')" :search="searchComentario1">
                <template v-slot:item.acciones="{ item }">
                    <v-icon @click="prepararEdicion(item)" class="mr-2" >mdi-pencil</v-icon>
                    <v-icon @click="comentario = item, dialogEliminar = true">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <br>    
        <h1>Comentarios públicos</h1>
        <v-card :loading="loading">
            <v-card-title>
                <v-text-field
                    v-model="searchComentario2"
                    append-icon="mdi-account-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headersListarComentarios" :items="separarComentarios('publico')" :search="searchComentario2">
                <template v-slot:item.acciones="{ item }">
                    <v-icon @click="prepararEdicion(item)" class="mr-2">mdi-pencil</v-icon>
                    <v-icon @click="comentario = item, dialogEliminar = true">mdi-delete</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <!-- CREAR -->
        <v-btn fab dark color="teal lighten-1" @click="dialogNuevoComentario=true; ejecutarFoco()" fixed style="bottom: 37px; right: 30px;">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row justify="center">
            <v-dialog v-model="dialogNuevoComentario" persistent width="500">
                <v-card>
                    <v-card-title class="headline">Nuevo comentario</v-card-title>
                    <v-card-text class="pb-0">
                        <div class="text-h6">
                            <v-text-field 
                                label="Texto del comentario" 
                                class="mt-2 pb-2" 
                                v-model="textoNuevoComentario" 
                                hide-details
                                ref="input"
                                autofocus
                            >
                            </v-text-field>
                            <v-radio-group v-model="tipoNuevoComentario" row>
                                <v-radio label="Comentario Privado" value="0"></v-radio>
                                <v-radio label="Comentario Público" value="1"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="finCrearComentario()">Cancelar</v-btn>
                        <v-btn color="green" text @click="crearComentario()" :disabled="this.$v.textoNuevoComentario.$invalid || this.$v.tipoNuevoComentario.$invalid">Crear</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- ELIMINAR -->
        <v-row justify="center">
            <v-dialog v-model="dialogEliminar" persistent width="500">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text><div class="text-h6">{{contenidoDialogEliminar()}}</div></v-card-text>
                    <v-checkbox v-if="comentario.publico === 1" class="mt-0 ml-5" v-model="selected" label="Entiendo que al eliminar este comentario, se eliminará para todos los usuarios." value="true"></v-checkbox>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="finDialogEliminar()">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminar()" :disabled="comentario.publico === 1 && selected === false || selected === null">Eliminar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- EDITAR -->
        <v-row justify="center">
            <v-dialog v-model="dialogEditar" persistent width="500">
                <v-card>
                    <v-card-title class="headline">Editar comentario</v-card-title>
                    <v-card-text class="pb-0">
                        <div class="text-h6">
                            <v-text-field label="Texto del comentario" class="mt-4" filled v-model="textoNuevoComentario" hide-details></v-text-field> 
                            <v-radio-group v-model="tipoNuevoComentario" row>
                                <v-radio label="Comentario Privado" value="0"></v-radio>
                                <v-radio label="Comentario Público" value="1"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="finEditarComentario()">Cancelar</v-btn>
                        <v-btn color="green" text @click="editarComentario()" :disabled="this.$v.textoNuevoComentario.$invalid">Editar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'mis_comentarios',
    data: () => ({
        comentario: {},
        comentarios: [],
        headersListarComentarios: [
            {
                text: 'Comentario',
                align: 'start',
                filterable: true,
                sortable: false,
                value: 'texto'
            },
            {
                text: 'Acciones',
                align: 'right',
                filterable: false,
                sortable: false,
                value: 'acciones'
            }
        ],
        dialogNuevoComentario: false,
        nuevoComentario:{
            texto: '',
            publico: '0',
        },
        textoNuevoComentario: '',
        tipoNuevoComentario: '0',
        loading: false,
        search: '',
        dialogEliminar: false,
        dialogEditar: false,
        selected: false,
        searchComentario1: '',
        searchComentario2: '',
    }),
    validations: {
      textoNuevoComentario: { required },
      tipoNuevoComentario: { required }
    },
    created(){
        this.recuperarDatos();
    },
    methods: {
        ...mapActions(['setLoading', 'setSnackbar']),
        async recuperarDatos(){
            this.loading = true;
            try{
                let respuesta = await axios.get('/api/comentarios');//RECUPERAR COMENTARIOS BDD
                this.comentarios = respuesta.data;

                this.loading = false;   
            } catch (error) {
                this.loading = false;   
                this.setSnackbar({
                    tipo: "error",
                    mensaje: "Error. No se han podido recuperar los datos",
                });
            }
        },
        separarComentarios(tipo){
            let comentarios = [];
            this.comentarios.forEach(comentario => {
                if((comentario.publico === 1 || comentario.publico === '1') && tipo === 'publico'){
                    comentarios.push(comentario);
                }else if ((comentario.publico === 0 || comentario.publico === '0') && tipo === 'privado'){
                    comentarios.push(comentario);
                };
            });
            return comentarios;
        },
        contenidoDialogEliminar(){
            if(this.comentario.publico === 1 || this.comentario.publico === '1'){
                return 'Este comentario es público! ¿Realmente quieres eliminarlo?';
            }else {
                return '¿Realmente quieres eliminarlo?';
            }
        },
        finDialogEliminar(){
            this.dialogEliminar = false;
            this.selected = false;
        },
        eliminar(){
            axios.delete('/api/comentarios/'+ this.comentario.id).then(response => {
                this.comentarios = this.comentarios.filter(c => c !== this.comentario); // comenatios = a todos los comentarios menos el que se acaba de eliminar
                this.finDialogEliminar();
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Comentario eliminado correctamente'
                });
            }).catch(error => { 
                //console.log(error); 
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido eliminar el comentario'
                });
            });
        },
        crearComentario(){
            let comentario= {
                // id: this.comentarios.length < 1 ? 1 : this.comentarios[this.comentarios.length-1].id+1,//si no existe ningun comentario asignamos el id 1, sino miramos el id del ultimo comentario y le sumamos 1
                texto: this.textoNuevoComentario,
                publico: this.tipoNuevoComentario
            };
            
            axios.post('/api/comentarios', comentario).then(respuesta => {//AÑADIMOS COMENTARIO EN BDD
                this.recuperarDatos();
                this.finCrearComentario();
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Comentario creado correctamente'
                });
            }).catch(error => { 
                //console.log(error); 
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido crear el comentario'
                });
            }); 
        },
        finCrearComentario(){
            this.dialogNuevoComentario = false;
            this.textoNuevoComentario = '';
            this.tipoNuevoComentario = '0';
        },
        prepararEdicion(item){
            this.dialogEditar = true; 
            this.comentario = item; 
            this.textoNuevoComentario= this.comentario.texto,
            this.tipoNuevoComentario= this.comentario.publico.toString()
        },
        editarComentario(){
            this.comentario.texto = this.textoNuevoComentario;
            this.comentario.publico = this.tipoNuevoComentario;
            
            axios.patch('/api/comentarios', this.comentario).then(response => {//MODIFICAR COMENTARIO EN BDD
                this.finEditarComentario();
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Comentario editado correctamente'
                });
            }).catch(error => { 
                //console.log(error); 
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido editar correctamente el comentario'
                });
            });
        },
        finEditarComentario(){
            this.dialogEditar = false;
            this.textoNuevoComentario = '';
            this.tipoNuevoComentario = '0';
        },
        ejecutarFoco(){
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        }
    }
}
</script>
<style>
    
</style>